import { NgClass } from '@angular/common';
import { Component, inject, input, ViewChild } from '@angular/core';
import { LanguageService } from '@shared-angular/services/language.service';
import { LoginService } from '@shared-angular/services/login.service';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ButtonModule } from "primeng/button";
import { TooltipModule } from 'primeng/tooltip';
import { GlobalSearchComponent } from '../../global-search/global-search.component';

@Component({
  selector: 'app-page-header',
  imports: [NgClass, PopoverModule, GlobalSearchComponent, TooltipModule, ButtonModule],
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss'
})
export class PageHeaderComponent {
  public readonly projectOverview = input(false);
  @ViewChild('globalSearch') public globalSearch!: GlobalSearchComponent;
  public loginService: LoginService = inject(LoginService);
  public langService: LanguageService = inject(LanguageService);

  public openSearch(): void {
    this.globalSearch.open();
  }
}
